export const environment = {
    production: false,
	chat: false,
    contextPath: '',
    assertsContextPath: '/doctolys'
};
